import React from 'react'
import ModalContent from './ModalContent';

function Modal({ setOpenModal, modalContent, setModalContent}) {

    const example = () =>         
    <ModalContent 
        setOpenModal={setOpenModal}
        setModalContent={setModalContent}
        title={"test title"}
        body={"Test Body"}
        continueTo={()=>{
          //console.log("continue from parent")
        }}
        fullImage={false}
        
    />

  return (
    modalContent ? modalContent : undefined

  ) 
}

export default Modal;
